import { post } from './http'
import global from '@/api/global'
var name = global.zhbEss
// ---------------运单管理---------------------
// 字典表
export const getDictionaryList = p => post(name + '/bZhbDictionary/getDictionaryList', p)
// 运单查询-列表
export const getAllWaybillList = p => post(name + '/waybill/getAllWaybillList', p)
// 运单查询-修改
export const saveWaybill = p => post(name + '/waybill/saveWaybill', p)
// 运单查询-获取磅单图片
export const getWayBillWharfWeight = p => post(name + `/waybill/getWayBillWharfWeight/${p}`)
// 运单查询-重推进厂
export const getZhbWayweightListWbNo = p => post(name + '/waybill/getZhbWayweightListWbNo', p)
// 运单查询-强制推送
export const enforcementBytWaybillQuery = p => post(name + '/waybill/enforcementBytWaybillQuery', p)
// 运单查询-App重置
export const appRest = p => post(name + `/waybill/appRest/${p}`)
// 运单查询-历史轨迹
export const getVehicleHistory = p => post(name + '/waybill/getVehicleHistory', p)
// 运单查询-历史轨迹列表
export const getPoiDetail = p => post(name + '/waybill/getPoiDetail', p)
// 运单查询-实时位置
export const getVehicleAddress = p => post(name + '/waybill/getVehicleAddress', p)
// 运单查询-收货仓库
export const bPlantInfoList = p => post(name + '/bPlantInfo/list ', p)
// 实时监控
export const getVehicleMonitor = p => post(name + '/vehicleMonitor/getVehicleMonitor', p)
// 异常记录
export const getVehicleException = p => post(name + '/vehicleMonitor/getVehicleException', p)
// 修改备注
export const updateRemark = p => post(name + '/vehicleMonitor/updateRemark', p)
// ---------------派车管理---------------------
// 异常派车-备案车辆列表
export const getAbnormalCarDataList = p => post(name + '/abnormalCarData/getAbnormalCarDataList', p)
// 异常派车-非备案车辆列表
export const getNonAbnormalCarDataList = p => post(name + '/abnormalCarData/getNonAbnormalCarDataList', p)

//  计划发布页面的计划发布列表
export const getPurchasePlanList = p => post(name + '/plan/purchase/getPurchasePlanList', p)
// 获取计划状态
export const getPurPlanStatusList = p => post(name + '/plan/purchase/purPlanStatusList')
// 获取采购计划
export const getPurchaseList = p => post(name + '/plan/purchase/getPurchaseList', p)
// 计划修改
export const getPurchasePlanInfo = p => post(name + '/plan/purchase/getPurchasePlanInfo', p)
// 计划修改保存
export const savePlan = p => post(name + '/plan/purchase/savePlan', p)
// 计划编辑删除
export const delPurplanWarehouse = p => post(name + '/plan/purchase/delPurplanWarehouse', p)
// 计划完成情况
export const planCompletionInfo = p => post(name + '/plan/distribution/planCompletionInit', p)
// 生成计划：采购计划获取页面的确定按钮触发
export const createPlan = p => post(name + '/plan/purchase/createPlan', p)
// 发布计划
export const publishPlan = p => post(name + '/plan/purchase/publishPlan', p)
// 撤销发布计划
export const revocationPlan = p => post(name + `/plan/purchase/revocationPlan/${p}`)
// 锁定计划
export const lockPurchasePlan = p => post(name + '/plan/purchase/lockPurchasePlan', p)
// 解锁计划
export const unlockPurchasePlan = p => post(name + '/plan/purchase/unlockPurchasePlan', p)
// 计划分配页面的查询计划列表
export const getDisPurchasePlanList = p => post(name + '/plan/distribution/getPurchasePlanList', p)
// 计划分配页面获取计划状态列表
export const getDisPlanStatusList = p => post(name + '/plan/distribution/getDisPlanStatusList')
// 收货仓库列表
export const getPlantList = p => post(name + '/plan/purchase/getPlantList')
// 运单状态列表
export const wayBillStatusList = p => post(name + '/plan/distribution/wayBillStatusList')
// 计划完成情况页面的运单详情
export const getWaybillList = p => post(name + '/plan/distribution/getWaybillList', p)
// 查询修改计划分配信息
export const distributionInfoEdit = p => post(name + '/plan/distribution/distributionInfoEdit', p)
// 锁定与解锁分配的计划
export const distributionLock = p => post(name + '/plan/distribution/distributionLock', p)
// 保存修改的分配的计划
export const saveDistributionEdit = p => post(name + '/plan/distribution/saveDistributionEdit', p)
// 修改或分配计划时获取计划信息
export const getPlanInfoForDistribution = p => post(name + '/plan/distribution/getPlanInfoForDistribution', p)
// ---------------绑定疏港计划页面---------------------
// 获取车队的下拉框列表
export const fleetList = p => post(name + '/plan/distribution/fleetList')
// 绑定疏港计划页面的展示列表
export const getBindSGplanList = p => post(name + '/plan/distribution/getBindSGplanList', p)
// 计划绑定页面点击绑定(查询操作)
export const getBindSGbigPlan = (params, flag) => post(name + `/plan/distribution/getBindSGbigPlan/${flag}`, params)
// 绑定确定按钮实施
export const bindByDistributionIds = (planFlags, distributionId) => post(name + `/plan/distribution/bindByDistributionIds/${distributionId}`, planFlags)
// 绑定页面点击查看按钮
export const getFindBindedList = p => post(name + '/plan/distribution/getFindBindedList', p)
// 绑定页面点击解绑按钮（查询操作）
// export const getUnBindsgList = p => post(name + '/plan/distribution/getUnBindsgList', p)
// 解绑操作
export const unBindByPlanIds = p => post(name + '/plan/distribution/unBindByPlanIds', p)

// 统计分析-车队完成情况
export const fleetOverState = p => post(name + '/waybill/fleetOverState', p)
// 统计分析-车队完成情况统计
export const fleetOverCollect = p => post(name + '/waybill/fleetOverCollect', p)
// 派车管理-唐山港派车
export const getSendCarList = p => post(name + '/sendCar/getSendCarList', p)
// 获取港口下拉列表
export const getPortOptions = p => post(name + '/plan/distribution/getPortOptions')
// 派车管理-唐山港派车-可派车辆-头部信息
export const countSendCar = p => post(name + '/sendCar/countSendCar', p)
// 派车管理-唐山港派车-可派车辆-列表
export const getVehicleReportList = p => post(name + '/sendCar/getVehicleReportList', p)
// 派车管理-唐山港派车-已派车辆-列表
export const getVehicleYPList = p => post(name + '/sendCar/getVehicleYPList', p)
// 派车管理-唐山港派车-查看
export const getBindPlanList = p => post(name + '/sendCar/getBindPlanList', p)
// 统计分析-统计报表-平均出车趟数
export const fleetAvgSendCarTotal = p => post(name + '/waybill/fleetAvgSendCarTotal', p)
// 统计分析-统计报表-车辆出勤
export const fleetSendCarTotal = p => post(name + '/waybill/fleetSendCarTotal', p)
// 统计分析-统计报表-明细
export const vehSendCarTotal = p => post(name + '/waybill/vehSendCarTotal', p)
// 统计分析-平均出车趟数-动态设置时间
export const avgSendCar = p => post(name + '/waybill/avgSendCar', p)

// 计划分配页面新加按钮获取港口计划
export const getTempEvacuatePlan = p => post(name + '/plan/distribution/getTempEvacuatePlan', p)

// 统计分析-统计报表-车辆出勤
export const fleetSendCarCount = p => post(name + '/waybill/fleetSendCarCount', p)
// 统计分析-统计报表-车辆出车明细
export const vehSendCount = p => post(name + '/waybill/vehSendCount', p)

// 未激活运单查询
export const validFind = p => post(name + '/waybill/validFind', p)
// 校验中厚板账号
export const checkUserBelongToZhb = p => post(name + '/bZhbDictionary/checkUserBelongToZhb', p)
